// GTM dataLayer 経由の GA4 計測共通フック。
// data-gtm-event="event_name" data-gtm-{key}="value" の要素を delegated listener で捕捉。
// 詳細: .spec/KNOWLEDGE-tier4-base.md §3-2 / DESIGN-tier4-a §4-2
(function () {
  'use strict';
  if (typeof document === 'undefined') return;
  if (window._gtmEventsInit) return;
  window._gtmEventsInit = true;

  function pushEvent(target) {
    var ds = target.dataset || {};
    var event = ds.gtmEvent;
    if (!event) return;
    var payload = { event: event };
    Object.keys(ds).forEach(function (key) {
      if (key === 'gtmEvent') return;
      if (key === 'gtmEventOn') return;
      if (key.indexOf('gtm') === 0) {
        var paramKey = key.slice(3, 4).toLowerCase() + key.slice(4);
        payload[paramKey] = ds[key];
      }
    });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  // bubble phase (capture: true は使わない、Bootstrap dropdown / modal の listener 順序を保護)
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-gtm-event]');
    if (el) pushEvent(el);
  });

  // change イベント (form filter / sort 用)
  document.addEventListener('change', function (e) {
    var el = e.target.closest('[data-gtm-event-on="change"]');
    if (el) pushEvent(el);
  });
})();
